import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {ActionResult, FormParametrizations} from "@model";
import {EnvironmentService} from "./environment.service";

@Injectable({ providedIn:'root' })
export class FormParametrizationService {

  constructor(private http: HttpClient, private environmentService:EnvironmentService) {
  }

  getByRaceRegistration(raceId: number, onSuccess: (formParametrizations: FormParametrizations[] | undefined) => void, onError: () => void) {
    this.http.post<ActionResult<FormParametrizations[]>>(this.environmentService.getApiUrl() + "/api/public/formparameterization/getbyraceregistration/" + raceId.toString(), {}).subscribe((actionResult: ActionResult<FormParametrizations[]>) => {
      onSuccess(actionResult.result);
    }, (error: any) => {
      onError();
    });
  }
}

